import {
  COMPARE_MONTHS_SALES_SUCCESS,
  COMPARE_MONTHS_LOADING
} from '../actions/CompareMonthAction';

const initialState = {
  amazon: {
    compareMonthSalesData: null,
    isLoading: true
  },
  shopify: {
    compareMonthSalesData: null,
    isLoading: true
  },
  wholesale: {
    compareMonthSalesData: null,
    isLoading: true
  }
};

const compareMonthSalesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case COMPARE_MONTHS_SALES_SUCCESS:
      return {
        ...state, [action?.vendor]: { compareMonthSalesData: action.data, isLoading: false }
      };
    case COMPARE_MONTHS_LOADING:
      return { ...state, [action.vendor]: { ...state?.[action.vendor], isLoading: action.isLoading } };

    default:
      return state;
  }
};

export default compareMonthSalesReducer;
